import { KYMW0C00Model } from '../kymw0c00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　Ｐコードを取得するサービス
 *
 * @export GetPCodeDataService
 * @class GetPCodeDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPCodeDataService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetPCodeDataService
   */
  private model: KYMW0C00Model;

  /**
   * APIへの引数 Pコード
   *
   * @private
   * @type {string}
   * @memberof GetPCodeDataService
   */
  private pCode: string = <string>'';

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPCodeDataService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPCodeDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPCodeDataService
   */
  execute(model: any, pcode: string, successFunc: Function): void {
    this.model = <KYMW0C00Model>model;
    this.pCode = pcode;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetPCodeData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPCodeDataService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
